import { Box, Grid, Typography } from "@mui/material";
import { useIntl } from "react-intl";
import useLoginSignupStyles from "./styles";
import I18nKey from "translations/I18nKey";

export const TryFreeOption = () => {
  const intl = useIntl();
  const classes = useLoginSignupStyles();
  const options = [
    {
      title: intl.formatMessage({
        id: I18nKey.PRICING_TITLE_MONTH_SIGNUP,
      }),
      subTitle: "19.99",
    },
    {
      title: intl.formatMessage({
        id: I18nKey.PRICING_TITLE_QUARTER_SIGNUP,
      }),
      subTitle: "14.99",
      monthText: intl.formatMessage({
        id: I18nKey.PER_MONTH_SIGNUP,
      }),
    },
    {
      title: intl.formatMessage({
        id: I18nKey.PRICING_TITLE_YEAR_SIGNUP,
      }),
      subTitle: "9.99",
      monthText: intl.formatMessage({
        id: I18nKey.PER_MONTH_SIGNUP,
      }),
    },
    {
      title: intl.formatMessage({
        id: I18nKey.PRICING_TITLE_AUTOPAY_SIGNUP,
      }),
      subTitle: "9.99",
      monthText: intl.formatMessage({
        id: I18nKey.PER_MONTH_SIGNUP,
      }),
    },
  ];
  return (
    <>
      <fieldset className={classes.tryFreeContainer}>
        <legend>
          <Typography className={classes.tryFreeTitle}>
            {intl.formatMessage({
              id: I18nKey.TRY_FREE_TITLE,
            })}
          </Typography>
        </legend>
        <Typography className={classes.tryFreeSubTitle}>
          {intl.formatMessage({
            id: I18nKey.TRY_FREE_SUBTITLE,
          })}
        </Typography>
        <Grid container spacing={2} className={classes.optionContainer}>
          {options.map((e) => (
            <Grid item xs={3} className={classes.optionBox}>
              <Typography className={classes.optionTitle}>{e.title}</Typography>
              <Typography>${e.subTitle}</Typography>
              {e.monthText && (
                <Typography className={classes.monthText}>
                  {e.monthText}
                </Typography>
              )}
            </Grid>
          ))}
        </Grid>
      </fieldset>
    </>
  );
};
